// extracted by mini-css-extract-plugin
export var dividerLine = "_3l-0";
export var errorBackground = "_3l-1";